<template>
  <div class="sc-root">

    <div class="sc-filters">
      <div class="sc-filter-group">
        <label class="sc-filter-label">Tipo de relatório</label>
        <div class="sc-select-wrap">
          <i class="fas fa-chart-bar sc-select-icon"></i>
          <select class="sc-select" v-model="rel">
            <option disabled value="">Selecione...</option>
            <option value="rel-analitico">Visão Geral de Campanha</option>
            <option value="rel-log">Log da Campanha</option>
            <!-- <option value="rel-nps">Relatório de NPS</option> -->
          </select>
          <i class="fas fa-chevron-down sc-select-arrow"></i>
        </div>
      </div>

      <div class="sc-filter-group">
        <label class="sc-filter-label">Campanha</label>
        <div class="sc-dd" ref="ddRoot">
          <button type="button" class="sc-dd-trigger" @click="toggleDropdown">
            <i class="fas fa-bullhorn sc-select-icon"></i>
            <span class="sc-dd-trigger-label" :class="{ 'sc-dd-trigger-label--placeholder': !selectedCampanhas.length }">
              {{ selectedLabel }}
            </span>
            <button v-if="selectedCampanhas.length" type="button" class="sc-dd-trigger-clear" title="Limpar seleção"
              @click.stop="clearSelection">
              <i class="fas fa-times"></i>
            </button>
            <i class="fas fa-chevron-down sc-select-arrow" :class="{ 'sc-select-arrow--open': ddOpen }"></i>
          </button>

          <div v-if="ddOpen" class="sc-dd-panel">
            <div class="sc-dd-search-wrap">
              <i class="fas fa-search sc-dd-search-icon"></i>
              <input ref="searchInput" v-model="search" type="text" class="sc-dd-search"
                placeholder="Pesquisar campanha..." @keydown="onSearchKeydown" />
              <button v-if="search" type="button" class="sc-dd-search-clear" @click="search = ''" title="Limpar busca">
                <i class="fas fa-times"></i>
              </button>
            </div>

            <div class="sc-dd-list">
              <div v-if="!dropdownOptions.length" class="sc-dd-empty">Nenhuma campanha encontrada.</div>
              <button v-for="(opt, i) in dropdownOptions" :key="opt.value" type="button" class="sc-dd-item"
                :class="{ 'sc-dd-item--active': isChecked(opt), 'sc-dd-item--highlighted': i === highlightedIndex }"
                @click="toggleOption(opt)" @mouseenter="highlightedIndex = i">
                <span class="sc-dd-chk" :class="{ 'sc-dd-chk--on': isChecked(opt) }">
                  <i v-if="isChecked(opt)" class="fas fa-check"></i>
                </span>
                <span class="sc-dd-item-label">{{ opt.label }}</span>
              </button>
            </div>

            <div class="sc-dd-footer">
              <span class="sc-dd-footer-count">
                {{ selectedCampanhas.length ? selectedCampanhas.length + ' selecionada(s)' : 'Todas as campanhas' }}
              </span>
              <button type="button" class="sc-dd-footer-close" @click="closeDropdown">Fechar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="sc-filter-group sc-filter-group--refresh">
        <label class="sc-filter-label">&nbsp;</label>
        <button type="button" class="sc-refresh-btn" :disabled="!rel" :class="{ 'sc-refresh-btn--spinning': refreshing }"
          title="Atualizar relatório" @click="refreshReport">
          <i class="fas fa-sync-alt"></i>
          Atualizar
        </button>
      </div>
    </div>

    <div v-if="!rel" class="sc-empty">
      <div class="sc-empty-icon-wrap">
        <i class="fas fa-chart-pie"></i>
      </div>
      <p class="sc-empty-title">Nenhum relatório selecionado</p>
      <p class="sc-empty-sub">Escolha o tipo de relatório e a campanha nos filtros acima.</p>
    </div>

    <div v-else class="sc-report-wrap">
      <component :is="rel" :key="rel + ':' + selectedCampanhas.join(',') + ':' + refreshKey"
        :filter="selectedCampanhas" />
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import RelAnalitico from './RelAnalitico.vue';
import RelLog from './RelLog.vue';
import RelAuster from './RelAuster.vue';
import RelPapeSantander from './RelPapeSantander.vue';
import RelNps from './RelNps.vue';

export default {
  components: { RelAnalitico, RelLog, RelAuster, RelPapeSantander, RelNps },
  data() {
    return {
      campanhas: [],
      rel: '',
      // Array de nomes de campanha selecionados. Vazio = "todas as campanhas".
      selectedCampanhas: [],
      search: '',
      ddOpen: false,
      highlightedIndex: -1,
      refreshKey: 0,
      refreshing: false
    };
  },
  computed: {
    dropdownOptions() {
      var items = [{ value: 'todos', label: 'Todas as campanhas' }]
        .concat(this.campanhas.map(function (c) { return { value: c, label: c }; }));

      var q = this.search.trim().toLowerCase();
      if (!q) return items;

      return items.filter(function (item) {
        return item.label.toLowerCase().includes(q);
      });
    },
    selectedLabel() {
      if (!this.selectedCampanhas.length) return 'Todas as campanhas';
      if (this.selectedCampanhas.length === 1) return this.selectedCampanhas[0];
      return this.selectedCampanhas.length + ' campanhas selecionadas';
    }
  },
  created() {
    axios.get('/marketing/distinctCampanhas').then(({ data }) => { this.campanhas = data; });
  },
  mounted() {
    document.addEventListener('click', this.onClickOutside);
    document.addEventListener('keydown', this.onGlobalKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onClickOutside);
    document.removeEventListener('keydown', this.onGlobalKeydown);
  },
  methods: {
    toggleDropdown() {
      this.ddOpen = !this.ddOpen;
      if (this.ddOpen) {
        this.highlightedIndex = -1;
        this.$nextTick(() => {
          if (this.$refs.searchInput) this.$refs.searchInput.focus();
        });
      }
    },
    closeDropdown() {
      this.ddOpen = false;
      this.search = '';
      this.highlightedIndex = -1;
    },
    isChecked(opt) {
      if (opt.value === 'todos') return this.selectedCampanhas.length === 0;
      return this.selectedCampanhas.indexOf(opt.value) !== -1;
    },
    toggleOption(opt) {
      if (opt.value === 'todos') {
        this.selectedCampanhas = [];
        return;
      }
      var idx = this.selectedCampanhas.indexOf(opt.value);
      if (idx === -1) this.selectedCampanhas = this.selectedCampanhas.concat([opt.value]);
      else this.selectedCampanhas = this.selectedCampanhas.slice(0, idx).concat(this.selectedCampanhas.slice(idx + 1));
    },
    clearSelection() {
      this.selectedCampanhas = [];
    },
    onClickOutside(e) {
      if (this.ddOpen && this.$refs.ddRoot && !this.$refs.ddRoot.contains(e.target)) {
        this.closeDropdown();
      }
    },
    onGlobalKeydown(e) {
      if (e.key === 'Escape' && this.ddOpen) this.closeDropdown();
    },
    onSearchKeydown(e) {
      var opts = this.dropdownOptions;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        this.highlightedIndex = Math.min(this.highlightedIndex + 1, opts.length - 1);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        this.highlightedIndex = Math.max(this.highlightedIndex - 1, 0);
      } else if (e.key === 'Enter') {
        e.preventDefault();
        var idx = this.highlightedIndex >= 0 ? this.highlightedIndex : 0;
        if (opts[idx]) this.toggleOption(opts[idx]);
      } else if (e.key === 'Escape') {
        this.closeDropdown();
      }
    },
    refreshReport() {
      if (!this.rel) return;
      this.refreshing = true;
      this.refreshKey++;
      // apenas feedback visual do botão; o remount do <component> acima
      // já dispara o carregamento real de dados do relatório atual
      setTimeout(() => { this.refreshing = false; }, 500);
    }
  }
};
</script>

<style scoped>
.sc-root {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.sc-filters {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 24px;
  align-items: flex-end;
}

.sc-filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 200px;
}

.sc-filter-group--refresh {
  flex: 0 0 auto;
  min-width: 0;
}

.sc-filter-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .05em;
  color: #667781;
  margin: 0;
}

.sc-select-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.sc-select-icon {
  position: absolute;
  left: 12px;
  font-size: 13px;
  color: #adb5bd;
  pointer-events: none;
  z-index: 1;
}

.sc-select-arrow {
  position: absolute;
  right: 12px;
  font-size: 11px;
  color: #adb5bd;
  pointer-events: none;
  transition: transform .15s;
}

.sc-select-arrow--open {
  transform: rotate(180deg);
}

.sc-select {
  width: 100%;
  height: 40px;
  padding: 0 36px;
  border: 1.5px solid #e9edef;
  border-radius: 8px;
  font-size: 13px;
  color: #111b21;
  background: #fff;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  transition: border-color .15s;
}

.sc-select:focus {
  border-color: #00a884;
}

/* ---------- Dropdown multiselect pesquisável de campanha ---------- */

.sc-dd {
  position: relative;
}

.sc-dd-trigger {
  width: 100%;
  height: 40px;
  padding: 0 36px 0 36px;
  border: 1.5px solid #e9edef;
  border-radius: 8px;
  font-size: 13px;
  color: #111b21;
  background: #fff;
  outline: none;
  cursor: pointer;
  transition: border-color .15s;
  display: flex;
  align-items: center;
  position: relative;
  text-align: left;
  font-family: inherit;
}

.sc-dd-trigger:hover {
  border-color: #cfd6db;
}

.sc-dd-trigger:focus {
  border-color: #00a884;
}

.sc-dd-trigger-label {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sc-dd-trigger-label--placeholder {
  color: #adb5bd;
}

.sc-dd-trigger-clear {
  position: absolute;
  right: 30px;
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 50%;
  background: #f0f2f5;
  color: #667781;
  font-size: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sc-dd-trigger-clear:hover {
  background: #fecdd3;
  color: #be123c;
}

.sc-dd-panel {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1.5px solid #e9edef;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(17, 27, 33, .12);
  z-index: 20;
  overflow: hidden;
}

.sc-dd-search-wrap {
  position: relative;
  border-bottom: 1px solid #f0f2f5;
  display: flex;
  align-items: center;
}

.sc-dd-search-icon {
  position: absolute;
  left: 12px;
  font-size: 12px;
  color: #adb5bd;
  pointer-events: none;
}

.sc-dd-search {
  width: 100%;
  height: 40px;
  padding: 0 34px;
  border: none;
  outline: none;
  font-size: 13px;
  color: #111b21;
  background: transparent;
}

.sc-dd-search-clear {
  position: absolute;
  right: 8px;
  width: 20px;
  height: 20px;
  border: none;
  border-radius: 50%;
  background: #f0f2f5;
  color: #667781;
  font-size: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sc-dd-search-clear:hover {
  background: #e9edef;
}

.sc-dd-list {
  max-height: 240px;
  overflow-y: auto;
  padding: 4px;
}

.sc-dd-empty {
  padding: 16px 12px;
  font-size: 13px;
  color: #adb5bd;
  text-align: center;
}

.sc-dd-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
  border: none;
  border-radius: 6px;
  background: none;
  font-size: 13px;
  color: #111b21;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
}

.sc-dd-item-label {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sc-dd-item:hover,
.sc-dd-item--highlighted {
  background: #f8f9fa;
}

.sc-dd-item--active {
  background: #f0fdf4;
  color: #0a5e2a;
  font-weight: 600;
}

.sc-dd-chk {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  flex-shrink: 0;
  border: 2px solid #d1d7db;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  color: #fff;
}

.sc-dd-chk--on {
  border-color: #00a884;
  background: #00a884;
}

.sc-dd-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border-top: 1px solid #f0f2f5;
  background: #fafbfc;
}

.sc-dd-footer-count {
  font-size: 11px;
  color: #667781;
  font-weight: 600;
}

.sc-dd-footer-close {
  height: 28px;
  padding: 0 12px;
  border: 1.5px solid #e9edef;
  border-radius: 6px;
  background: #fff;
  color: #344054;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.sc-dd-footer-close:hover {
  border-color: #00a884;
  color: #00a884;
}

/* ---------- Botão atualizar ---------- */

.sc-refresh-btn {
  height: 40px;
  padding: 0 16px;
  border: 1.5px solid #e9edef;
  border-radius: 8px;
  background: #fff;
  color: #344054;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  transition: border-color .15s, color .15s, background .15s;
}

.sc-refresh-btn:hover:not(:disabled) {
  border-color: #00a884;
  color: #00a884;
  background: #f6fffb;
}

.sc-refresh-btn:disabled {
  opacity: .45;
  cursor: not-allowed;
}

.sc-refresh-btn--spinning i {
  animation: sc-spin .5s linear;
}

@keyframes sc-spin {
  to {
    transform: rotate(360deg);
  }
}

.sc-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 72px 20px;
  background: #fff;
  border: 1px solid #e9edef;
  border-radius: 16px;
  text-align: center;
}

.sc-empty-icon-wrap {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: #f0fdf4;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.sc-empty-icon-wrap i {
  font-size: 28px;
  color: #00a884;
}

.sc-empty-title {
  font-size: 16px;
  font-weight: 600;
  color: #343a40;
  margin: 0 0 6px;
}

.sc-empty-sub {
  font-size: 13px;
  color: #adb5bd;
  margin: 0;
  max-width: 340px;
  line-height: 1.5;
}

.sc-report-wrap {
  background: #fff;
  border: 1px solid #e9edef;
  border-radius: 16px;
  overflow: hidden;
}
</style>